import React from 'react';
import { Helmet } from 'react-helmet';

import HeaderNavbar from './MainHeader';
import SidebarOryza from './SidebarOryza';
import Sidebar from './SideNavigation';
import Header from './Header';
import Footer from './Footer';
import '../styles/room.css'
import HorizontalImageScroller from './imageslider';



const EightBedDormitory = () => {
    const currentDate = new Date();
  const formattedDate = currentDate.toLocaleDateString('en-US', { 
    month: 'short', 
    day: 'numeric', 
    year: 'numeric' 
  });

  const tomorrowDate = new Date(currentDate);
  tomorrowDate.setDate(currentDate.getDate() + 1);
  const formattedTomorrowDate = tomorrowDate.toLocaleDateString('en-US', { 
    month: 'short', 
    day: 'numeric', 
    year: 'numeric' 
  });
  
  return (
    <div className="home page-template-default page page-id-15043 theme-hotale gdlr-core-body tourmaster-body woocommerce-no-js hotale-body hotale-body-front hotale-full hotale-with-sticky-navigation hotale-blockquote-style-3 gdlr-core-link-to-lightbox">
      <Helmet>
        <title>Bed in 8-Bed Dormitory Room | Banana Bunks Kandy | Oryza Leisure</title>
        <link rel="stylesheet" id="gdlr-core-google-font-css" href="https://fonts.googleapis.com/css?family=Jost%3A100%2C200%2C300%2Cregular%2C500%2C600%2C700%2C800%2C900%2C100italic%2C200italic%2C300italic%2Citalic%2C500italic%2C600italic%2C700italic%2C800italic%2C900italic%7CAmiri%3Aregular%2Citalic%2C700%2C700italic%7CAllison%3Aregular&#038;subset=cyrillic%2Clatin%2Clatin-ext%2Carabic%2Cvietnamese&#038;ver=6.0.1" type="text/css" media="all" />
        <link rel="stylesheet" id="gdlr-core-google-font-css" href="https://fonts.googleapis.com/css?family=Oswald%3A200%2C300%2Cregular%2C500%2C600%2C700%7CMerriweather%3A300%2C300italic%2Cregular%2Citalic%2C700%2C700italic%2C900%2C900italic%7CJost%3A100%2C200%2C300%2Cregular%2C500%2C600%2C700%2C800%2C900%2C100italic%2C200italic%2C300italic%2Citalic%2C500italic%2C600italic%2C700italic%2C800italic%2C900italic%7CMontserrat%3A100%2C100italic%2C200%2C200italic%2C300%2C300italic%2Cregular%2Citalic%2C500%2C500italic%2C600%2C600italic%2C700%2C700italic%2C800%2C800italic%2C900%2C900italic%7CAllison%3Aregular&#038;subset=cyrillic%2Ccyrillic-ext%2Clatin%2Clatin-ext%2Cvietnamese&#038;ver=6.0.1" type="text/css" media="all" />
        <link href="https://fonts.googleapis.com/css2?family=Boogaloo&family=Lato:wght@100;300;400;900&display=swap" rel="stylesheet" />
        <link href="https://fonts.googleapis.com/css2?family=Handlee&family=Neucha&family=Pacifico&family=Patrick+Hand&family=Patrick+Hand+SC&family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Sacramento&display=swap" rel="stylesheet" />
        <link href="https://fonts.googleapis.com/css2?family=Yellowtail&display=swap" rel="stylesheet" />
        <script src="https://code.jquery.com/jquery-3.6.0.min.js"></script>

<script src="https://cdnjs.cloudflare.com/ajax/libs/gsap/3.11.4/gsap.min.js"></script>
<script src="https://cdnjs.cloudflare.com/ajax/libs/gsap/3.11.4/ScrollTrigger.min.js"></script>
<script src="https://cdnjs.cloudflare.com/ajax/libs/ScrollMagic/2.0.8/ScrollMagic.min.js"></script>
<script src="https://cdnjs.cloudflare.com/ajax/libs/ScrollMagic/2.0.8/plugins/animation.gsap.min.js"></script>


<script src="jss/common_functions.js"></script>

<script src="https://unpkg.com/headroom.js@0.12.0/dist/headroom.min.js"></script>
<script src="https://unpkg.com/headroom.js@0.12.0/dist/jQuery.headroom.min.js"></script>
        <script src="https://ajax.googleapis.com/ajax/libs/jquery/2.1.1/jquery.min.js"></script>
        <script src="/bbkandy/js/script.js"></script>
        <script src="https://kit.fontawesome.com/a076d05399.js" crossorigin="anonymous"></script>
      </Helmet>

      

      <Header />
            <HeaderNavbar />
            <SidebarOryza />
            <Sidebar />

      <div className="hotale-page-title-wrap hotale-style-custom hotale-center-align" style={{backgroundImage: "url(/bbkandy/images/rooms/roomheader.webp)"}}>
        <div className="hotale-header-transparent-substitute" style={{height: "135px"}}></div>
        <div className="hotale-page-title-overlay"></div>
        <div className="hotale-page-title-container hotale-container">
          <div className="hotale-page-title-content hotale-item-pdlr">
            <h1 className="hotale-page-title hotale-additional-font"><b>Bed in 8-Bed Dormitory Room</b></h1>
          </div>
        </div>
      </div>

      <div className="gdlr-core-page-builder-body bbkandybg" style={{paddingTop: "40px", paddingBottom: "40px"}}>
        <div className="gdlr-core-pbf-sidebar-wrapper gdlr-core-js" id="gdlr-core-sidebar-wrapper-1">
          <div className="gdlr-core-pbf-sidebar-container gdlr-core-line-height-0 clearfix gdlr-core-js gdlr-core-container">
            <div className="gdlr-core-pbf-sidebar-content gdlr-core-column-45 gdlr-core-pbf-sidebar-padding gdlr-core-line-height gdlr-core-column-extend-left green_back_second" style={{marginBottom: "20px"}}>
              <div className="gdlr-core-pbf-sidebar-content-inner">
                <div className="gdlr-core-pbf-column gdlr-core-column-60 gdlr-core-column-first">
                  <div className="gdlr-core-pbf-column-content-margin gdlr-core-js">
                    <div className="gdlr-core-pbf-column-content clearfix gdlr-core-js">
                      <div className="gdlr-core-pbf-element">
                        <div className="gdlr-core-image-item gdlr-core-item-pdb gdlr-core-center-align gdlr-core-item-pdlr">
                          <div className="gdlr-core-image-item-wrap gdlr-core-media-image gdlr-core-image-item-style-round" style={{borderWidth: "0px", borderRadius: "20px", MozBorderRadius: "20px", WebkitBorderRadius: "20px"}}>
                            <img src="/bbkandy/images/rooms/8bed/1.webp" alt="" width="1150" height="490" title="Bed in 8-Bed Dormitory Room" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                
                <div className="gdlr-core-pbf-column gdlr-core-column-60 gdlr-core-column-first" id="gdlr-core-column-1">
                  <div className="gdlr-core-pbf-column-content-margin gdlr-core-js" style={{margin: "0px 0px 0px 0px", padding: "10px 0px 20px 0px"}}>
                    <div className="gdlr-core-pbf-background-wrap"></div>
                    <div className="gdlr-core-pbf-column-content clearfix gdlr-core-js">
                      <div className="gdlr-core-pbf-element">
                        <div className="tourmaster-room-title-item tourmaster-item-mglr tourmaster-item-pdb clearfix" style={{paddingBottom: "35px"}}>
                          <h3 className="tourmaster-room-title-item-title" style={{color: "#3A4A26"}}>Bed in 8-Bed Dormitory Room</h3>
                          <div className="tourmaster-room-title-item-caption greencolor">Room Features</div>
                        </div>
                      </div>
                      <div className="gdlr-core-pbf-element">
                        <div className="gdlr-core-divider-item gdlr-core-divider-item-normal gdlr-core-item-pdlr gdlr-core-center-align">
                          <div className="gdlr-core-divider-line gdlr-core-skin-divider"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="gdlr-core-pbf-column gdlr-core-column-20 gdlr-core-column-first" id="gdlr-core-column-2">
                  <div className="gdlr-core-pbf-column-content-margin gdlr-core-js">
                    <div className="gdlr-core-pbf-background-wrap"></div>
                    <div className="gdlr-core-pbf-column-content clearfix gdlr-core-js">
                      <div className="gdlr-core-pbf-element">
                        <div className="gdlr-core-column-service-item gdlr-core-item-pdb gdlr-core-left-align gdlr-core-column-service-icon-left gdlr-core-with-caption gdlr-core-item-pdlr" style={{paddingBottom: "20px"}}>
                          <div className="gdlr-core-column-service-media gdlr-core-media-icon">
                            <i className="gdlr-icon-double-bed2" style={{fontSize: "33px", lineHeight: "33px", width: "33px", color: "#3A4A26"}}></i>
                          </div>
                          <div className="gdlr-core-column-service-content-wrapper">
                            <div className="gdlr-core-column-service-title-wrap">
                              <h3 className="gdlr-core-column-service-title gdlr-core-skin-title greencolor" style={{fontSize: "19px", fontWeight: "600", textTransform: "none", color: "#3A4A26"}}>Bed</h3>
                              <div className="gdlr-core-info-font gdlr-core-skin-caption" style={{fontSize: "17px", fontWeight: "500", fontStyle: "normal", marginTop: "0px", color: "#3A4A26"}}>
                                8 Single Bunk Beds
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="gdlr-core-pbf-column gdlr-core-column-20" id="gdlr-core-column-3">
                  <div className="gdlr-core-pbf-column-content-margin gdlr-core-js">
                    <div className="gdlr-core-pbf-background-wrap"></div>
                    <div className="gdlr-core-pbf-column-content clearfix gdlr-core-js">
                      <div className="gdlr-core-pbf-element">
                        <div className="gdlr-core-column-service-item gdlr-core-item-pdb gdlr-core-left-align gdlr-core-column-service-icon-left gdlr-core-with-caption gdlr-core-item-pdlr" style={{paddingBottom: "20px"}}>
                          <div className="gdlr-core-column-service-media gdlr-core-media-icon" style={{marginTop: "0px", marginRight: "26px"}}>
                            <i className="gdlr-icon-group" style={{fontSize: "40px", lineHeight: "40px", width: "40px", color: "#3A4A26"}}></i>
                          </div>
                          <div className="gdlr-core-column-service-content-wrapper">
                            <div className="gdlr-core-column-service-title-wrap">
                              <h3 className="gdlr-core-column-service-title gdlr-core-skin-title greencolor" style={{fontSize: "19px", fontWeight: "600", textTransform: "none", color: "#3A4A26"}}>Max Guest</h3>
                              <div className="gdlr-core-info-font gdlr-core-skin-caption greencolor" style={{fontSize: "17px", fontWeight: "500", fontStyle: "normal", marginTop: "0px"}}>
                                8 Guest per Dormitory
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="gdlr-core-pbf-column gdlr-core-column-20">
                  <div className="gdlr-core-pbf-column-content-margin gdlr-core-js">
                    <div className="gdlr-core-pbf-column-content clearfix gdlr-core-js"></div>
                  </div>
                </div>

                <div className="gdlr-core-pbf-column gdlr-core-column-20 gdlr-core-column-first" id="gdlr-core-column-4">
                  <div className="gdlr-core-pbf-column-content-margin gdlr-core-js">
                    <div className="gdlr-core-pbf-background-wrap"></div>
                    <div className="gdlr-core-pbf-column-content clearfix gdlr-core-js">
                      <div className="gdlr-core-pbf-element">
                        <div className="gdlr-core-column-service-item gdlr-core-item-pdb gdlr-core-left-align gdlr-core-column-service-icon-left gdlr-core-with-caption gdlr-core-item-pdlr" style={{paddingBottom: "20px"}}>
                          <div className="gdlr-core-column-service-media gdlr-core-media-icon">
                            <i className="gdlr-icon-resize" style={{fontSize: "34px", lineHeight: "34px", width: "34px", color: "#3A4A26"}}></i>
                          </div>
                          <div className="gdlr-core-column-service-content-wrapper">
                            <div className="gdlr-core-column-service-title-wrap">
                              <h3 className="gdlr-core-column-service-title gdlr-core-skin-title greencolor" style={{fontSize: "19px", fontWeight: "600", textTransform: "none", color: "#3A4A26"}}>Room Space</h3>
                              <div className="gdlr-core-info-font gdlr-core-skin-caption greencolor" style={{fontSize: "17px", fontWeight: "500", fontStyle: "normal", marginTop: "0px"}}>
                                45 sqm
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="gdlr-core-pbf-column gdlr-core-column-60 gdlr-core-column-first" id="gdlr-core-column-6">
                  <div className="gdlr-core-pbf-column-content-margin gdlr-core-js" style={{padding: "10px 0px 0px 0px"}}>
                    <div className="gdlr-core-pbf-background-wrap"></div>
                    <div className="gdlr-core-pbf-column-content clearfix gdlr-core-js">
                      <div className="gdlr-core-pbf-element">
                        <div className="gdlr-core-text-box-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-left-align">
                          <div className="gdlr-core-text-box-item-content greencolor" style={{fontSize: "18px", textTransform: "none"}}>
                            <p>This bed in dormitory features a washing machine.</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="gdlr-core-pbf-column gdlr-core-column-60 gdlr-core-column-first" id="gdlr-core-column-7">
                  <div className="gdlr-core-pbf-column-content-margin gdlr-core-js" style={{margin: "0px 0px 0px 0px", padding: "0px 0px 25px 0px"}}>
                    <div className="gdlr-core-pbf-background-wrap"></div>
                    <div className="gdlr-core-pbf-column-content clearfix gdlr-core-js">
                      <div className="gdlr-core-pbf-element">
                        <div className="gdlr-core-divider-item gdlr-core-divider-item-normal gdlr-core-item-pdlr gdlr-core-center-align">
                          <div className="gdlr-core-divider-line gdlr-core-skin-divider"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="gdlr-core-pbf-column gdlr-core-column-60 gdlr-core-column-first">
                  <div className="gdlr-core-pbf-column-content-margin gdlr-core-js">
                    <div className="gdlr-core-pbf-column-content clearfix gdlr-core-js">
                      <div className="gdlr-core-pbf-element">
                        <div className="gdlr-core-title-item gdlr-core-item-pdb clearfix gdlr-core-left-align gdlr-core-title-item-caption-top gdlr-core-item-pdlr" style={{paddingBottom: "40px"}}>
                          <div className="gdlr-core-title-item-title-wrap">
                            <h3 className="gdlr-core-title-item-title gdlr-core-skin-title class-test" style={{fontSize: "25px", fontWeight: "500", letterSpacing: "0px", textTransform: "none"}}>
                              Room Amenities
                            </h3>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="gdlr-core-pbf-column gdlr-core-column-20 gdlr-core-column-first" id="gdlr-core-column-8">
                  <div className="gdlr-core-pbf-column-content-margin gdlr-core-js gdlr-core-move-up-with-shadow" style={{margin: "0px 10px 20px 20px", padding: "25px 0px 0px 10px", borderRadius: "20px 20px 20px 20px", MozBorderRadius: "20px 20px 20px 20px", WebkitBorderRadius: "20px 20px 20px 20px"}}>
                    <div className="gdlr-core-pbf-background-wrap" style={{borderRadius: "20px 20px 20px 20px", MozBorderRadius: "20px 20px 20px 20px", WebkitBorderRadius: "20px 20px 20px 20px", borderWidth: "1px 1px 1px 1px", borderColor: "#3A4A26", borderStyle: "solid"}}></div>
                    <div className="gdlr-core-pbf-column-content clearfix gdlr-core-js">
                      <div className="gdlr-core-pbf-element">
                        <div className="gdlr-core-title-item gdlr-core-item-pdb clearfix gdlr-core-left-align gdlr-core-title-item-caption-top gdlr-core-item-pdlr pleft" style={{paddingBottom: "10px"}}>
                          <div className="gdlr-core-title-item-left-icon" style={{margin: "-12px 16px 0px 0px", fontSize: "35px"}}>
                            <i className="gdlr-icon-watch-tv" style={{color: "#3A4A26"}}></i>
                          </div>
                          <div className="gdlr-core-title-item-left-icon-wrap">
                            <div className="gdlr-core-title-item-title-wrap">
                              <h3 className="gdlr-core-title-item-title gdlr-core-skin-title class-test" style={{fontSize: "17px", fontWeight: "500", letterSpacing: "0px", textTransform: "none", color: "#3A4A26"}}>
                                TV
                              </h3>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="gdlr-core-pbf-column gdlr-core-column-20" id="gdlr-core-column-9">
                  <div className="gdlr-core-pbf-column-content-margin gdlr-core-js gdlr-core-move-up-with-shadow" style={{margin: "0px 10px 20px 10px", padding: "25px 0px 0px 10px", borderRadius: "20px 20px 20px 20px", MozBorderRadius: "20px 20px 20px 20px", WebkitBorderRadius: "20px 20px 20px 20px"}}>
                    <div className="gdlr-core-pbf-background-wrap" style={{borderRadius: "20px 20px 20px 20px", MozBorderRadius: "20px 20px 20px 20px", WebkitBorderRadius: "20px 20px 20px 20px", borderWidth: "1px 1px 1px 1px", borderColor: "#3A4A26", borderStyle: "solid"}}></div>
                    <div className="gdlr-core-pbf-column-content clearfix gdlr-core-js">
                      <div className="gdlr-core-pbf-element">
                        <div className="gdlr-core-title-item gdlr-core-item-pdb clearfix gdlr-core-left-align gdlr-core-title-item-caption-top gdlr-core-item-pdlr pleft" style={{paddingBottom: "10px"}}>
                          <div className="gdlr-core-title-item-left-icon" style={{margin: "-12px 15px 0px 0px", fontSize: "35px"}}>
                            <i className="gdlr-icon-wifi-signal" style={{color: "#3A4A26"}}></i>
                          </div>
                          <div className="gdlr-core-title-item-left-icon-wrap">
                            <div className="gdlr-core-title-item-title-wrap">
                              <h3 className="gdlr-core-title-item-title gdlr-core-skin-title class-test" style={{fontSize: "17px", fontWeight: "500", letterSpacing: "0px", textTransform: "none", color: "#3A4A26"}}>
                                Free Wifi
                              </h3>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="gdlr-core-pbf-column gdlr-core-column-20" id="gdlr-core-column-10">
                  <div className="gdlr-core-pbf-column-content-margin gdlr-core-js gdlr-core-move-up-with-shadow" style={{margin: "0px 10px 20px 10px", padding: "25px 0px 0px 10px", borderRadius: "20px 20px 20px 20px", MozBorderRadius: "20px 20px 20px 20px", WebkitBorderRadius: "20px 20px 20px 20px"}}>
                    <div className="gdlr-core-pbf-background-wrap" style={{borderRadius: "20px 20px 20px 20px", MozBorderRadius: "20px 20px 20px 20px", WebkitBorderRadius: "20px 20px 20px 20px", borderWidth: "1px 1px 1px 1px", borderColor: "#3A4A26", borderStyle: "solid"}}></div>
                    <div className="gdlr-core-pbf-column-content clearfix gdlr-core-js">
                      <div className="gdlr-core-pbf-element">
                        <div className="gdlr-core-title-item gdlr-core-item-pdb clearfix gdlr-core-left-align gdlr-core-title-item-caption-top gdlr-core-item-pdlr pleft" style={{paddingBottom: "10px"}}>
                          <div className="gdlr-core-title-item-left-icon" style={{margin: "-12px 15px 0px 0px", fontSize: "35px"}}>
                            <i className="gdlr-icon-air-conditioner1" style={{color: "#3A4A26"}}></i>
                          </div>
                          <div className="gdlr-core-title-item-left-icon-wrap">
                            <div className="gdlr-core-title-item-title-wrap">
                              <h3 className="gdlr-core-title-item-title gdlr-core-skin-title class-test" style={{fontSize: "17px", fontWeight: "500", letterSpacing: "0px", textTransform: "none", color: "#3A4A26"}}>
                                Air Conditioning
                              </h3>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="gdlr-core-pbf-column gdlr-core-column-20 gdlr-core-column-first" id="gdlr-core-column-14">
                  <div className="gdlr-core-pbf-column-content-margin gdlr-core-js gdlr-core-move-up-with-shadow" style={{margin: "0px 10px 20px 20px", padding: "25px 0px 0px 10px", borderRadius: "20px 20px 20px 20px", MozBorderRadius: "20px 20px 20px 20px", WebkitBorderRadius: "20px 20px 20px 20px"}}>
                    <div className="gdlr-core-pbf-background-wrap" style={{borderRadius: "20px 20px 20px 20px", MozBorderRadius: "20px 20px 20px 20px", WebkitBorderRadius: "20px 20px 20px 20px", borderWidth: "1px 1px 1px 1px", borderColor: "#3A4A26", borderStyle: "solid"}}></div>
                    <div className="gdlr-core-pbf-column-content clearfix gdlr-core-js">
                      <div className="gdlr-core-pbf-element">
                        <div className="gdlr-core-title-item gdlr-core-item-pdb clearfix gdlr-core-left-align gdlr-core-title-item-caption-top gdlr-core-item-pdlr pleft" style={{paddingBottom: "10px"}}>
                          <div className="gdlr-core-title-item-left-icon" style={{margin: "-12px 16px 0px 0px", fontSize: "35px"}}>
                            <i className="gdlr-icon-telephone" style={{color: "#3A4A26"}}></i>
                          </div>
                          <div className="gdlr-core-title-item-left-icon-wrap">
                            <div className="gdlr-core-title-item-title-wrap">
                              <h3 className="gdlr-core-title-item-title gdlr-core-skin-title class-test" style={{fontSize: "17px", fontWeight: "500", letterSpacing: "0px", textTransform: "none", color: "#3A4A26"}}>
                                Phone
                              </h3>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="gdlr-core-pbf-column gdlr-core-column-20" id="gdlr-core-column-15">
                  <div className="gdlr-core-pbf-column-content-margin gdlr-core-js gdlr-core-move-up-with-shadow" style={{margin: "0px 10px 20px 10px", padding: "25px 0px 0px 10px", borderRadius: "20px 20px 20px 20px", MozBorderRadius: "20px 20px 20px 20px", WebkitBorderRadius: "20px 20px 20px 20px"}}>
                    <div className="gdlr-core-pbf-background-wrap" style={{borderRadius: "20px 20px 20px 20px", MozBorderRadius: "20px 20px 20px 20px", WebkitBorderRadius: "20px 20px 20px 20px", borderWidth: "1px 1px 1px 1px", borderColor: "#3A4A26", borderStyle: "solid"}}></div>
                    <div className="gdlr-core-pbf-column-content clearfix gdlr-core-js">
                      <div className="gdlr-core-pbf-element">
                        <div className="gdlr-core-title-item gdlr-core-item-pdb clearfix gdlr-core-left-align gdlr-core-title-item-caption-top gdlr-core-item-pdlr pleft" style={{paddingBottom: "10px"}}>
                          <div className="gdlr-core-title-item-left-icon" style={{margin: "-12px 15px 0px 0px", fontSize: "35px"}}>
                            <i className="gdlr-icon-hair-dryer1" style={{color: "#3A4A26"}}></i>
                          </div>
                          <div className="gdlr-core-title-item-left-icon-wrap">
                            <div className="gdlr-core-title-item-title-wrap">
                              <h3 className="gdlr-core-title-item-title gdlr-core-skin-title class-test" style={{fontSize: "17px", fontWeight: "500", letterSpacing: "0px", textTransform: "none", color: "#3A4A26"}}>
                                Hair Dryer
                              </h3>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="gdlr-core-pbf-column gdlr-core-column-20" id="gdlr-core-column-21">
                  <div className="gdlr-core-pbf-column-content-margin gdlr-core-js gdlr-core-move-up-with-shadow" style={{margin: "0px 10px 20px 10px", padding: "25px 0px 0px 10px", borderRadius: "20px 20px 20px 20px", MozBorderRadius: "20px 20px 20px 20px", WebkitBorderRadius: "20px 20px 20px 20px"}}>
                    <div className="gdlr-core-pbf-background-wrap" style={{borderRadius: "20px 20px 20px 20px", MozBorderRadius: "20px 20px 20px 20px", WebkitBorderRadius: "20px 20px 20px 20px", borderWidth: "1px 1px 1px 1px", borderColor: "#3A4A26", borderStyle: "solid"}}></div>
                    <div className="gdlr-core-pbf-column-content clearfix gdlr-core-js">
                      <div className="gdlr-core-pbf-element">
                        <div className="gdlr-core-title-item gdlr-core-item-pdb clearfix gdlr-core-left-align gdlr-core-title-item-caption-top gdlr-core-item-pdlr pleft" style={{paddingBottom: "10px"}}>
                          <div className="gdlr-core-title-item-left-icon" style={{margin: "-12px 15px 0px 0px", fontSize: "35px"}}>
                            <i className="gdlr-icon-food-service-copy" style={{color: "#3A4A26"}}></i>
                          </div>
                          <div className="gdlr-core-title-item-left-icon-wrap">
                            <div className="gdlr-core-title-item-title-wrap">
                              <h3 className="gdlr-core-title-item-title gdlr-core-skin-title class-test" style={{fontSize: "17px", fontWeight: "500", letterSpacing: "0px", textTransform: "none", color: "#3A4A26"}}>
                                Room Service
                              </h3>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

             {/* Booking Sidebar */}
            <div className="gdlr-core-pbf-sidebar-right gdlr-core-column-extend-right hotale-sidebar-area gdlr-core-column-15 gdlr-core-pbf-sidebar-padding gdlr-core-line-height bookingwidth " style={{paddingBottom: "20px"}}>
              <div className="gdlr-core-sidebar-item gdlr-core-item-pdlr">
                <div className="tourmaster-room-booking-bar-wrap">
                  <div className="tourmaster-room-booking-bar-title greencolor" style={{ backgroundColor: '#eeb85e', paddingBottom: '10px', paddingTop: '10px', borderRadius: '15px', paddingLeft: '15px' }}>Book Your Bed</div>
                  <div className="tourmaster-room-booking-bar-content">
                    <div className="tourmaster-room-booking-wrap" data-room-tab="booking">
                      <form
                        className="tourmaster-room-booking-form clearfix"
                        id="tourmaster-room-booking-form"
                        action="https://app.channelmanager.com.au/booknow/Chain/kent-chain-135"
                        target="_blank"
                        data-action="tourmaster_room_booking_form"
                        method="POST"
                      >
                        <div
                          className=" disable-booking-sidebar tourmaster-room-date-selection tourmaster-vertical" style={{ paddingTop: '20px' }}
                        >
                          <div className="tourmaster-custom-start-date gdlr-core-skin-e-background">
                            <div className="tourmaster-head gdlr-core-skin-e-content">Check In</div>
                            <div className="tourmaster-tail gdlr-core-skin-e-content" style={{backgroundColor : "#EEB85E"}}>{formattedDate}</div>
                            <input type="hidden" name="start_date" id="datePicker" />
                          </div>
                          <div className="tourmaster-custom-end-date gdlr-core-skin-e-background">
                            <div className="tourmaster-head gdlr-core-skin-e-content">Check Out</div>
                            <div className="tourmaster-tail gdlr-core-skin-e-content" style={{backgroundColor : "#EEB85E"}}>{formattedTomorrowDate}</div>
                            <input type="hidden" name="end_date" id="datePickertomorrow" />
                          </div>
                          <div className="tourmaster-custom-datepicker-wrap" data-date-format="d M yy">
                            <i className="tourmaster-custom-datepicker-close icon_close"></i>
                            <div className="tourmaster-custom-datepicker-title"></div>
                            <div className="tourmaster-custom-datepicker-calendar"></div>
                          </div>
                        </div>
                        <div className="tourmaster-room-amount-selection disable-booking-sidebar">
                          <div className="tourmaster-custom-amount-display gdlr-core-skin-e-background">
                            <div className="tourmaster-head gdlr-core-skin-e-content">Room</div>
                            <div className="tourmaster-tail gdlr-core-skin-e-content" style={{backgroundColor : "#EEB85E"}}><span className="tourmaster-space"></span>1</div>
                          </div>
                          <div className="tourmaster-custom-amount-selection-wrap" style={{backgroundColor : "#EEB85E"}}>
                            <div className="tourmaster-custom-amount-selection-item clearfix" style={{backgroundColor : "#EEB85E"}}>
                              <div className="tourmaster-head">Room</div>
                              <div className="tourmaster-tail" style={{backgroundColor : "#EEB85E"}}>
                                <span className="tourmaster-minus"><i className="icon_minus-06"></i></span><span className="tourmaster-amount">1</span>
                                <span className="tourmaster-plus"><i className="icon_plus"></i></span>
                              </div>
                              <input type="hidden" name="room_amount" value="1" />
                            </div>
                          </div>
                        </div>
                        <div className="disable-booking-sidebar tourmaster-room-booking-guest-selection tourmaster-one">
                          <div className="tourmaster-room-amount-selection">
                            <div className="tourmaster-custom-amount-display gdlr-core-skin-e-background">
                              <div className="tourmaster-head gdlr-core-skin-e-content">
                                <span>Room<span className="tourmaster-number">1</span> : </span>Guests
                              </div>
                              <div className="tourmaster-tail gdlr-core-skin-e-content" style={{backgroundColor : "#EEB85E"}}><span className="tourmaster-space"></span>Adults 2<span className="tourmaster-space"></span>Children 0</div>
                            </div>
                            <div className="tourmaster-custom-amount-selection-wrap disable-booking-sidebar" style={{backgroundColor : "#EEB85E"}}>
                              <div className="tourmaster-custom-amount-selection-item clearfix " style={{backgroundColor : "#EEB85E"}} data-label="Adults">
                                <div className="tourmaster-head">Adults</div>
                                <div className="tourmaster-tail" style={{backgroundColor : "#EEB85E"}}>
                                  <span className="tourmaster-minus"><i className="icon_minus-06"></i></span><span className="tourmaster-amount">2</span>
                                  <span className="tourmaster-plus"><i className="icon_plus"></i></span>
                                </div>
                                <input type="hidden" name="adult[]" value="2" />
                              </div>
                              <div className="tourmaster-custom-amount-selection-item clearfix disable-booking-sidebar"  style={{backgroundColor : "#EEB85E"}}data-label="Children">
                                <div className="tourmaster-head">Children</div>
                                <div className="tourmaster-tail" style={{backgroundColor : "#EEB85E"}}>
                                  <span className="tourmaster-minus"><i className="icon_minus-06"></i></span><span className="tourmaster-amount">0</span>
                                  <span className="tourmaster-plus"><i className="icon_plus"></i></span>
                                </div>
                                <input type="hidden" name="children[]" value="0" />
                              </div>
                            </div>
                          </div>
                        </div>
                        <input type="hidden" name="room_id" value="15031" />
                        <input type="hidden" name="post_type" value="room" />
                        <input type="submit" className="tourmaster-room-button tourmaster-full" value="Check Availability" />
                      </form>
                    </div>
                    <div className="tourmaster-room-enquiry-wrap" data-room-tab="enquiry">
                      <form
                        className="tourmaster-enquiry-form tourmaster-form-field tourmaster-room clearfix"
                        id="tourmaster-enquiry-form"
                        data-action="tourmaster_room_send_enquiry_form"
                        data-validate-error="Please fill all required fields."
                      >
                        <div className="tourmaster-enquiry-field tourmaster-enquiry-field-full-name tourmaster-type-text clearfix">
                          <div className="tourmaster-head">Full Name<span className="tourmaster-req">*</span></div>
                          <div className="tourmaster-tail clearfix"><input type="text" name="full-name" value="" data-required /></div>
                        </div>
                        <div className="tourmaster-enquiry-field tourmaster-enquiry-field-email-address tourmaster-type-text clearfix">
                          <div className="tourmaster-head">Email Address<span className="tourmaster-req">*</span></div>
                          <div className="tourmaster-tail clearfix"><input type="text" name="email-address" value="" data-required /></div>
                        </div>
                        <div className="tourmaster-enquiry-field tourmaster-enquiry-field-your-enquiry tourmaster-type-textarea clearfix">
                          <div className="tourmaster-head">Your Enquiry<span className="tourmaster-req">*</span></div>
                          <div className="tourmaster-tail clearfix"><textarea name="your-enquiry" data-required></textarea></div>
                        </div>
                        <div className="tourmaster-enquiry-term">
                      <input type="checkbox" name="tourmaster-require-acceptance" />* I agree with 
                    <a href="https://oryzalesure.uw.r.appspot.com/BananaBunksKandy/room/bedin6bed" target="_blank" rel="noreferrer">Terms of Service</a> and 
                    <a href="https://oryzalesure.uw.r.appspot.com/BananaBunksKandy/room/bedin6bed" target="_blank" rel="noreferrer">Privacy Statement</a>.
                          <div className="tourmaster-enquiry-term-message tourmaster-enquiry-form-message tourmaster-failed">Please agree to all the terms and conditions before proceeding to the next step</div>
                        </div>
                        <div className="tourmaster-enquiry-form-message"></div>
                        <input type="hidden" name="room-id" value="15031" />
                        <input type="submit" className="tourmaster-room-button tourmaster-full" value="Submit Enquiry" />
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>



            <HorizontalImageScroller 
  basePath="/bbkandy/images/rooms/6bed/screens"
  imageCount={10}
/>
          </div>
        </div>
      </div>

      <script src="/bbkandy/jss/common_scripts.js"></script>
      <script src="/bbkandy/jss/common_functions.js"></script>
      <script src="/bbkandy/jss/slider.js"></script>
      <Footer />

    </div>
  );
};

export default EightBedDormitory;